import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'meu-mobile-botton-nav',
  templateUrl: './mobile-botton-nav.component.html',
  styleUrls: ['./mobile-botton-nav.component.scss'],
})
export class MobileBottonNavComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
